var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCompleto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 536,
    height: 95,
    viewBox: "0 0 536 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.5319 23.4953L81.3592 23.7938H81.534V70.7836H81.3276L40.7663 94.2012L40.7656 94.2004L0.204982 70.7836H0V23.7938H0.173336L0.000719236 23.4953L40.6951 0L40.7663 0.122989L40.8375 0L81.5319 23.4953ZM10.5929 29.6109V64.5485L40.7663 81.9691L70.9411 64.5478V29.6124L46.0642 15.2485V53.9844H35.4713V15.2471L10.5929 29.6109ZM60.1382 27.0871V66.4667H60.1051L60.1655 66.5717L40.7648 77.7724L40.7497 77.7472L40.7346 77.7745L21.334 66.5732L31.596 60.2662L40.7476 65.5497L49.6035 60.4374V21.3951L60.1382 27.0871Z",
    fill: "url(#paint0_linear_236_333)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M515.813 71.1904C512.135 71.1904 508.815 70.4054 505.855 68.8354C502.939 67.2654 500.629 65.0225 498.924 62.1068C497.264 59.1911 496.435 55.782 496.435 51.8794C496.435 48.0217 497.287 44.6349 498.991 41.7192C500.696 38.7587 503.029 36.4934 505.989 34.9234C508.95 33.3534 512.269 32.5684 515.947 32.5684C519.626 32.5684 522.945 33.3534 525.906 34.9234C528.866 36.4934 531.199 38.7587 532.903 41.7192C534.608 44.6349 535.46 48.0217 535.46 51.8794C535.46 55.7371 534.586 59.1462 532.836 62.1068C531.132 65.0225 528.777 67.2654 525.771 68.8354C522.811 70.4054 519.491 71.1904 515.813 71.1904ZM515.813 61.2321C518.011 61.2321 519.872 60.4247 521.398 58.8098C522.968 57.195 523.753 54.8848 523.753 51.8794C523.753 48.8739 522.99 46.5638 521.465 44.9489C519.985 43.3341 518.145 42.5267 515.947 42.5267C513.705 42.5267 511.843 43.3341 510.363 44.9489C508.882 46.5189 508.142 48.8291 508.142 51.8794C508.142 54.8848 508.86 57.195 510.295 58.8098C511.776 60.4247 513.615 61.2321 515.813 61.2321Z",
    fill: "url(#paint1_linear_236_333)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M476.261 32.7033C480.657 32.7033 484.156 34.1388 486.758 37.0096C489.404 39.8356 490.727 43.7382 490.727 48.7174V70.6525H479.289V50.2649C479.289 47.7529 478.638 45.8016 477.338 44.4111C476.037 43.0205 474.287 42.3252 472.089 42.3252C469.891 42.3252 468.142 43.0205 466.841 44.4111C465.54 45.8016 464.89 47.7529 464.89 50.2649V70.6525H453.384V33.1071H464.89V38.0862C466.056 36.4265 467.626 35.1256 469.6 34.1836C471.573 33.1968 473.794 32.7033 476.261 32.7033ZM460.045 29.9446C461.122 23.3058 464.217 19.9863 469.331 19.9863C470.317 19.9863 471.17 20.1433 471.887 20.4573C472.65 20.7265 473.57 21.1526 474.646 21.7358C475.454 22.1843 476.104 22.5208 476.597 22.745C477.091 22.9245 477.607 23.0142 478.145 23.0142C479.805 23.0142 480.769 22.0049 481.038 19.9863H486.959C485.883 26.6252 482.788 29.9446 477.674 29.9446C476.687 29.9446 475.812 29.8101 475.05 29.5409C474.332 29.2269 473.435 28.7783 472.358 28.1952C471.551 27.7466 470.901 27.4326 470.407 27.2532C469.914 27.0289 469.398 26.9168 468.86 26.9168C467.2 26.9168 466.213 27.926 465.899 29.9446H460.045Z",
    fill: "url(#paint2_linear_236_333)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M439.325 29.2037C437.306 29.2037 435.647 28.6206 434.346 27.4543C433.09 26.2432 432.462 24.7629 432.462 23.0134C432.462 21.2192 433.09 19.7389 434.346 18.5726C435.647 17.3614 437.306 16.7559 439.325 16.7559C441.299 16.7559 442.914 17.3614 444.17 18.5726C445.471 19.7389 446.121 21.2192 446.121 23.0134C446.121 24.7629 445.471 26.2432 444.17 27.4543C442.914 28.6206 441.299 29.2037 439.325 29.2037ZM445.044 33.1063V70.6518H433.538V33.1063H445.044Z",
    fill: "url(#paint3_linear_236_333)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M428.131 42.6616H421.941V70.6524H410.435V42.6616H406.263V33.107H410.435V32.0304C410.435 27.4101 411.758 23.9113 414.405 21.5338C417.051 19.1115 420.932 17.9004 426.045 17.9004C426.898 17.9004 427.526 17.9228 427.929 17.9677V27.7241C425.731 27.5895 424.184 27.9035 423.287 28.6661C422.389 29.4287 421.941 30.7968 421.941 32.7705V33.107H428.131V42.6616Z",
    fill: "url(#paint4_linear_236_333)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M401.028 33.1055V70.6509H389.522V65.5372C388.356 67.1969 386.763 68.5426 384.745 69.5744C382.771 70.5612 380.573 71.0546 378.151 71.0546C375.28 71.0546 372.746 70.4266 370.548 69.1706C368.35 67.8698 366.645 66.0082 365.434 63.5859C364.223 61.1636 363.617 58.3152 363.617 55.0406V33.1055H375.056V53.4931C375.056 56.0051 375.706 57.9563 377.007 59.3469C378.308 60.7375 380.057 61.4328 382.255 61.4328C384.498 61.4328 386.27 60.7375 387.571 59.3469C388.872 57.9563 389.522 56.0051 389.522 53.4931V33.1055H401.028Z",
    fill: "url(#paint5_linear_236_333)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M358.178 23.418V32.6361H345.663V70.6526H334.157V32.6361H321.642V23.418H358.178Z",
    fill: "url(#paint6_linear_236_333)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M286.62 32.7021C291.286 32.7021 294.986 34.1151 297.723 36.9411C300.504 39.7672 301.894 43.6922 301.894 48.7162V70.6513H290.456V50.2637C290.456 47.8414 289.805 45.9799 288.504 44.679C287.248 43.3333 285.499 42.6604 283.256 42.6604C281.013 42.6604 279.241 43.3333 277.941 44.679C276.685 45.9799 276.057 47.8414 276.057 50.2637V70.6513H264.618V50.2637C264.618 47.8414 263.967 45.9799 262.667 44.679C261.411 43.3333 259.661 42.6604 257.418 42.6604C255.175 42.6604 253.404 43.3333 252.103 44.679C250.847 45.9799 250.219 47.8414 250.219 50.2637V70.6513H238.713V33.1059H250.219V37.8159C251.385 36.2459 252.91 35.0123 254.794 34.1151C256.678 33.1731 258.809 32.7021 261.186 32.7021C264.012 32.7021 266.524 33.3077 268.722 34.5189C270.965 35.73 272.715 37.457 273.971 39.6999C275.272 37.6364 277.043 35.9543 279.286 34.6534C281.529 33.3526 283.974 32.7021 286.62 32.7021Z",
    fill: "url(#paint7_linear_236_333)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M190.757 51.8121C190.757 47.9544 191.475 44.5677 192.91 41.6519C194.39 38.7362 196.386 36.4934 198.898 34.9234C201.41 33.3534 204.214 32.5684 207.309 32.5684C209.956 32.5684 212.266 33.1066 214.24 34.1832C216.258 35.2598 217.806 36.6728 218.882 38.4222V33.1066H230.388V70.6521H218.882V65.3365C217.761 67.086 216.191 68.499 214.172 69.5755C212.199 70.6521 209.888 71.1904 207.242 71.1904C204.192 71.1904 201.41 70.4054 198.898 68.8354C196.386 67.2205 194.39 64.9552 192.91 62.0395C191.475 59.079 190.757 55.6698 190.757 51.8121ZM218.882 51.8794C218.882 49.0085 218.075 46.7432 216.46 45.0835C214.89 43.4238 212.961 42.5939 210.673 42.5939C208.386 42.5939 206.434 43.4238 204.82 45.0835C203.25 46.6984 202.465 48.9412 202.465 51.8121C202.465 54.6829 203.25 56.9707 204.82 58.6752C206.434 60.335 208.386 61.1648 210.673 61.1648C212.961 61.1648 214.89 60.335 216.46 58.6752C218.075 57.0155 218.882 54.7502 218.882 51.8794Z",
    fill: "url(#paint8_linear_236_333)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M186.975 51.2738C186.975 52.3504 186.908 53.4718 186.773 54.6381H160.734C160.913 56.9707 161.653 58.765 162.954 60.021C164.3 61.2321 165.937 61.8377 167.866 61.8377C170.737 61.8377 172.733 60.6265 173.854 58.2042H186.1C185.472 60.6714 184.328 62.8918 182.669 64.8655C181.054 66.8392 179.013 68.3868 176.546 69.5082C174.079 70.6297 171.32 71.1904 168.27 71.1904C164.591 71.1904 161.317 70.4054 158.446 68.8354C155.575 67.2654 153.332 65.0225 151.717 62.1068C150.102 59.1911 149.295 55.782 149.295 51.8794C149.295 47.9768 150.08 44.5677 151.65 41.6519C153.265 38.7362 155.508 36.4934 158.379 34.9234C161.249 33.3534 164.546 32.5684 168.27 32.5684C171.903 32.5684 175.133 33.3309 177.959 34.8561C180.785 36.3812 182.983 38.5568 184.553 41.3828C186.168 44.2088 186.975 47.5058 186.975 51.2738ZM175.2 48.2459C175.2 46.2722 174.527 44.7022 173.181 43.5359C171.836 42.3697 170.154 41.7865 168.135 41.7865C166.206 41.7865 164.569 42.3472 163.223 43.4687C161.922 44.5901 161.115 46.1825 160.801 48.2459H175.2Z",
    fill: "url(#paint9_linear_236_333)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M145.808 23.418V32.6361H133.293V70.6526H121.787V32.6361H109.271V23.418H145.808Z",
    fill: "url(#paint10_linear_236_333)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_236_333",
    x1: 40.767,
    y1: 6.79441,
    x2: 40.767,
    y2: 94.2012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408654,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_236_333",
    x1: 107.657,
    y1: 47.1015,
    x2: 598.843,
    y2: 47.1015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8531FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519231,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908654,
    stopColor: "#7CF0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_236_333",
    x1: 107.657,
    y1: 47.1027,
    x2: 598.843,
    y2: 47.1027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8531FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519231,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908654,
    stopColor: "#7CF0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_236_333",
    x1: 107.657,
    y1: 47.1018,
    x2: 598.843,
    y2: 47.1018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8531FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519231,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908654,
    stopColor: "#7CF0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_236_333",
    x1: 107.656,
    y1: 47.103,
    x2: 598.842,
    y2: 47.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8531FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519231,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908654,
    stopColor: "#7CF0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_236_333",
    x1: 107.657,
    y1: 47.1014,
    x2: 598.843,
    y2: 47.1014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8531FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519231,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908654,
    stopColor: "#7CF0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_236_333",
    x1: 107.657,
    y1: 47.1027,
    x2: 598.843,
    y2: 47.1027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8531FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519231,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908654,
    stopColor: "#7CF0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_236_333",
    x1: 107.657,
    y1: 47.1006,
    x2: 598.843,
    y2: 47.1006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8531FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519231,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908654,
    stopColor: "#7CF0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_236_333",
    x1: 107.657,
    y1: 47.1015,
    x2: 598.843,
    y2: 47.1015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8531FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519231,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908654,
    stopColor: "#7CF0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_236_333",
    x1: 107.657,
    y1: 47.1015,
    x2: 598.843,
    y2: 47.1015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8531FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519231,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908654,
    stopColor: "#7CF0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_236_333",
    x1: 107.657,
    y1: 47.1027,
    x2: 598.843,
    y2: 47.1027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8531FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519231,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908654,
    stopColor: "#7CF0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCompleto);
export default __webpack_public_path__ + "static/media/logo_completo.cc76cfc812b30f669802ce95d419d92c.svg";
export { ForwardRef as ReactComponent };